import React from 'react';

import { AppProvider } from './AppContext';
import { CapabilitiesProvider } from './capabilities';
import { HeaderExtensionsProvider } from './headerExtensions';

import Header from '../Header/components/Header';
import Footer from '../Footer/components/Footer';
import AppFeedback from './UI/AppFeedback/components/AppFeedback';
import AppRedirect from './UI/AppRedirect/components/AppRedirect';

export default function rootComponentWrapper(Component) {
  const App = (props) => {
    const { authenticatedUser } = props;

    return (
      <AppProvider>
        <CapabilitiesProvider
          defaultCapabilities={{
            showLoginNavigation: !authenticatedUser,
            showRequestInvitationNavigation: !authenticatedUser,
            showAdminCapabilities: !!authenticatedUser && authenticatedUser.isAdmin,
            showUserInvitationsNavigation: !!authenticatedUser && authenticatedUser.canIndexUserInvitations,
            showUsersNavigation: !!authenticatedUser && authenticatedUser.canIndexUsers,
            showGroupsNavigation: !!authenticatedUser,
            showEventsNavigation: !!authenticatedUser && authenticatedUser.canViewEvents,
            showAccountNavigation: !!authenticatedUser,
            showProfileNavigation: !!authenticatedUser,
            showJobProspectsNavigation: !!authenticatedUser,
            showAccountSettingsNavigation: !!authenticatedUser,
            showLogoutNavigation: !!authenticatedUser,
            showTagsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showJobDescriptionsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showJobDescriptionsFromFileUploadNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showBiopharmaGroupsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showAllJobProspectsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showArchivedJobProspectsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showEnrollmentManagementNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showJobDescriptionsFromExternalWebsitesNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showExternalJobBoardsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showLinkTextToAvoidInJobSearchesNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showSidekiqNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showJobProspectsStatsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showLoginRecordsNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showSessionTokensNavigation: !!authenticatedUser && authenticatedUser.isAdmin,
            showRolesNavigation: !!authenticatedUser && authenticatedUser.canAdministerRestrictedActions,
            showRestrictedActionsNavigation: !!authenticatedUser && authenticatedUser.canAdministerRestrictedActions,
            showInterestsNavigation: !!authenticatedUser && authenticatedUser.canAdministerInterests,
            showSkillsNavigation: !!authenticatedUser && authenticatedUser.canAdministerSkills,
            showAdminDiscourseNavigation: !!authenticatedUser && authenticatedUser.canAdministerDocuments,
          }}
        >
          <HeaderExtensionsProvider>
            <div id="appContainer">
              <Header { ...props } />
              <main id="main">
                <Component { ...props } />
              </main>
              <Footer { ...props } />
              <AppFeedback />
              <AppRedirect />
            </div>
          </HeaderExtensionsProvider>
        </CapabilitiesProvider>
      </AppProvider>
    );
  };

  return App;
};
